import reducer, { saga as sagas, actions } from './ducks';
import * as translations from './translations';
import widgets from './widgets';

export const name = 'cost';
export const realName = 'cost';
export { reducer, widgets, sagas, actions, translations };
export * from './routes';
